import { PERF } from '../const/perf.const';
import { detectSafari } from './detectBrowser.util';
import { getPerf } from './detectPerf.util';

export const isScrollEnabled = () => {
	return getPerf() > PERF.PERF_LOW && !detectSafari();
};
